<template>
  <div class="service-list-page">
    <div class="filter-panel">
      <a-form layout="inline" class="filter-form">
        <a-form-item label="筛选分类">
          <a-select
            v-model="category"
            allow-clear
            placeholder="请选择分类"
            style="width: 220px"
            @change="onCategoryChange"
          >
            <a-select-option
              v-for="item in categoryOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="关键词">
          <a-input-search
            v-model="keyword"
            allow-clear
            placeholder="请输入"
            enter-button="搜索"
            style="width: 320px"
            @search="onSearch"
          />
        </a-form-item>
      </a-form>
    </div>

    <a-spin :spinning="loading">
      <div v-if="list.length" class="card-grid">
        <div
          v-for="item in list"
          :key="item.id"
          class="service-card"
          @click="onCardClick(item)"
        >
          <div class="cover">
            <img :src="item.imageUrl || emptyImage" alt="">
          </div>
          <div class="body">
            <div class="title" :title="item.name">{{ item.name }}</div>
            <div class="desc" :title="item.description">{{ item.description }}</div>
            <a class="pin-btn" @click.stop="onPinClick(item)">
              <a-icon type="arrow-up"/>
              {{ item.pinned ? '取消置顶' : '置顶' }}
            </a>
          </div>
        </div>
      </div>
      <a-empty v-else-if="!loading"/>
    </a-spin>

    <div v-if="totalCount > pageSize" class="pagination-box">
      <a-pagination
        :current="pageNum"
        :total="totalCount"
        :page-size="pageSize"
        show-size-changer
        :show-total="total => `总共 ${total} 条`"
        @change="onPageChange"
        @showSizeChange="onShowSizeChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceListNew',
  data() {
    return {
      keyword: '',
      category: undefined,
      categoryOptions: [
        { label: '消息通知', value: 'notification' },
        { label: '营销工具', value: 'marketing' },
        { label: '效率工具', value: 'efficiency' }
      ],
      list: [],
      loading: false,
      pageNum: 1,
      pageSize: 10,
      totalCount: 0,
      emptyImage: 'https://imgb.woyoubooking.com/common/empty_pro_img.png'
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    getServeApi() {
      return this.getHttpServices().getNewServeService()
    },
    loadList() {
      this.loading = true
      const params = {
        category: this.category || '',
        keyword: this.keyword || '',
        limitDto: {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      }
      this.getServeApi()
        .post('server/list', params)
        .then(res => {
          this.list = (res && res.data) || []
          this.totalCount = (res && res.totalCount) || 0
        })
        .catch(reason => {
          this.list = []
          this.totalCount = 0
          this.showNetWorkErrorMessage(reason)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onCategoryChange() {
      this.pageNum = 1
      this.loadList()
    },
    onSearch() {
      this.pageNum = 1
      this.loadList()
    },
    onPageChange(page, pageSize) {
      this.pageNum = page
      this.pageSize = pageSize
      this.loadList()
    },
    onShowSizeChange(page, pageSize) {
      this.pageNum = 1
      this.pageSize = pageSize
      this.loadList()
    },
    onCardClick(item) {
      if (!item || !item.linkUrl) return
      if (item.linkUrl.startsWith('/')) {
        this.$router.push({ path: item.linkUrl })
        return
      }
      this.openNewPage(item.linkUrl)
    },
    onPinClick(item) {
      if (!item || !item.id) return
      this.getServeApi()
        .post(`server/pin?id=${encodeURIComponent(item.id)}`)
        .then(() => {
          this.$message.success(item.pinned ? '已取消置顶' : '置顶成功')
          this.loadList()
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>

<style scoped lang="less">
.service-list-page {
  min-height: 100%;
  //   padding: 24px;
  box-sizing: border-box;
}

.filter-panel {
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 4px;

  .filter-form {
    /deep/ .ant-form-item {
      margin-bottom: 0;
      margin-right: 24px;
    }
  }

  /deep/ .ant-input-search-button {
    background: #1890ff;
    border-color: #1890ff;
  }
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.service-card {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  .cover {
    width: 100%;
    height: 220px;
    background: #fafafa;
    overflow: hidden;

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .body {
    padding: 16px;
  }

  .title {
    font-size: 16px;
    font-weight: 600;
    color: #262626;
    line-height: 24px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .desc {
    margin-top: 8px;
    min-height: 40px;
    font-size: 13px;
    line-height: 20px;
    color: #8c8c8c;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .pin-btn {
    display: inline-flex;
    align-items: center;
    margin-top: 12px;
    font-size: 13px;
    color: #1890ff;

    .anticon {
      margin-right: 4px;
    }
  }
}

.pagination-box {
  margin-top: 24px;
  text-align: right;
}

@media (max-width: 1400px) {
  .card-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 992px) {
  .card-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .card-grid {
    grid-template-columns: 1fr;
  }
}
</style>
